import * as angular from "angular";
import {IFilterService} from "angular";
import {BringozToastService} from "./bringoz-toast.service";

export class ImportEntitiesAlertsService {

  constructor(private bringozToastService: BringozToastService, private $filter: IFilterService) {
  }

  getEntityImportPreviewError() {
    let message = {
      body: 'GET_ENTITY_PREVIEW_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getEntityImportValidationError(){
    let message = {
      body: 'GET_ENTITY_IMPORT_VALIDATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.commons')
  .service('importEntitiesAlertsService', ImportEntitiesAlertsService);
